export const COOKIE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  APP_VERSION: 'lAppVersion',
  USER_PROFILE: 'lUserProfile',
  MERCHANT_PREFERENCE: 'lMerchantPreference',
  SORT_PREFERENCE: 'lSortPreference',
} as const;
